// extracted by mini-css-extract-plugin
export default {"resultContainer":"ResultPage_resultContainer__TNEp0","result":"ResultPage_result__9jo1J"};